import { AxiosError, AxiosInstance, AxiosResponse } from 'axios'

import { useUser } from '../contexts'
import { LOCAL_STORAGE_KEYS } from '../constants'
import { removeAuthHeader } from '../api'

const setInterceptors = (api: AxiosInstance): AxiosInstance => {
  console.log('configuring interceptors')
  api.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      if (error.response?.status === 401 || error.response?.data.message === '401 Unauthorized') {
        const { setState } = useUser()
        setState(undefined)
        removeAuthHeader()
        window.localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)

        return Promise.reject(error)
      }
      // return Promise.resolve(error)
      return Promise.reject(error.response)
    },
  )
  return api
}

export { setInterceptors }
